// extracted by mini-css-extract-plugin
module.exports = {"title":"TopMistake_title__2WVB_","context":"TopMistake_context__3aI-R"};